export function initHeaderButtons() {
    /** @type {HTMLButtonElement} */
    const hamburger = document.querySelector('.page-header-hamburger');
    if( hamburger )
    hamburger.addEventListener('click', () => {
        document.body.classList.add('mobile-nav-open');
    });

    /** @type {HTMLButtonElement} */
    const overlayClose = document.querySelector('.page-header-overlay-close');
    if( overlayClose )
    overlayClose.addEventListener('click', () => {
        document.body.classList.remove('mobile-nav-open');
    });

    /** @type {NodeListOf<HTMLAnchorElement>} */
    const links = document.querySelectorAll('.page-header-link');
    if( links )
    for (const link of links) {
        link.addEventListener('touchend', e => {
            const parent = link.parentElement;
            const subnav = parent.querySelector('.page-header-subnav');
            if (parent.dataset.touched === 'true' || window.innerWidth < 1170 || !subnav) {
                return;
            }

            parent.dataset.touched = 'true';
            e.preventDefault();
        });
    }

    window.addEventListener('touchend', e => {
        for (const link of links) {
            if (e.target !== link) {
                delete link.parentElement.dataset.touched;
            }
        }
    });
}